import { render, staticRenderFns } from "./CoursePayment.vue?vue&type=template&id=0d563fa6"
import script from "./CoursePayment.vue?vue&type=script&lang=js"
export * from "./CoursePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports